package com.iregained.site.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.iregained.site.components.cms.CmsSection
import com.iregained.site.components.cms.DynamicSectionRenderer
import com.iregained.site.components.layouts.PageLayout
import com.iregained.site.components.widgets.BackToTopButton
import com.varabyte.kobweb.compose.css.dvh
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.Page

@Page("/patients")
@Composable
fun PatientsPage() {
    // simulated CMS payload for the Patients Page
    val pageSections = remember {
        listOf(
            CmsSection.PatientsHeroSection(),
            CmsSection.PatientsScienceEducationSection(),
            CmsSection.PatientsMyHandFeaturesSection(),
            CmsSection.PatientsRecoveryProtocolsSection(),
            CmsSection.PatientsFeaturesAccordionSection(),
            CmsSection.PatientsPricingOptionsSection(),
            CmsSection.PatientsFaqSection(),
            CmsSection.PatientsCtaSection()
        )
    }

    PageLayout{
        Column(
            modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // DYNAMIC RENDERER LOOP
            pageSections.forEach { section ->
                DynamicSectionRenderer(section)
            }
        }
        BackToTopButton()
    }
}